import { Component } from "@angular/core";

@Component({
  selector: "app-no-access",
  template: `
    <div class="af-wrap">
      <div class="af-card" style="padding:48px 24px;text-align:center;">
        <i class="bi bi-lock" style="font-size:34px;color:#6B7280;"></i>
        <h1 style="margin:14px 0 6px;font-size:20px;color:#1E2A5C;">You do not have access to this section</h1>
        <p style="margin:0;color:#6B7280;font-size:14px;">
          Ask an ISSO super admin to add it under Admin Users &amp; Roles.
        </p>
      </div>
    </div>
  `,
})
export class NoAccessComponent {}
